var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "dashboard-block", staticStyle: { margin: "20px" } },
    [
      _c("notification-exporter"),
      _vm._v(" "),
      _c(
        "form",
        { attrs: { method: "GET" } },
        [
          _c("h2", [_vm._v("Notification Preview")]),
          _vm._v(" "),
          _c("div", { staticClass: "row row-clear-md-4" }, [
            _c("div", { staticClass: "col-md-3" }, [
              _c("div", { staticClass: "form-group" }, [
                _c(
                  "label",
                  { staticClass: "control-label", attrs: { for: "user_type" } },
                  [_vm._v("User Type:")]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "input-group" }, [
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.user_type,
                          expression: "user_type",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: { name: "user_type" },
                      on: {
                        change: function ($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function (o) {
                              return o.selected
                            })
                            .map(function (o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.user_type = $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        },
                      },
                    },
                    _vm._l(_vm.user_options, function (option, index) {
                      return _c(
                        "option",
                        { key: index, domProps: { value: option } },
                        [_vm._v(_vm._s(option))]
                      )
                    }),
                    0
                  ),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-3" }, [
              _c(
                "label",
                { staticClass: "control-label", attrs: { for: "template" } },
                [_vm._v("Template:")]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "input-group" }, [
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.template,
                        expression: "template",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: { name: "template" },
                    on: {
                      change: function ($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function (o) {
                            return o.selected
                          })
                          .map(function (o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.template = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      },
                    },
                  },
                  _vm._l(_vm.options, function (option, index) {
                    return _c(
                      "option",
                      { key: index, domProps: { value: option } },
                      [_vm._v(_vm._s(option))]
                    )
                  }),
                  0
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-6 clear" }, [_vm._v(" ")]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-3" }, [
              _c("div", { staticClass: "form-group" }, [
                _c(
                  "label",
                  { staticClass: "control-label", attrs: { for: "user_id" } },
                  [_vm._v("User ID:")]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "input-group" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.user_id,
                        expression: "user_id",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: {
                      type: "number",
                      id: "user_id",
                      name: "user_id",
                      placeholder: "User ID",
                    },
                    domProps: { value: _vm.user_id },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.user_id = $event.target.value
                      },
                    },
                  }),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-3" }, [
              _c("div", { staticClass: "form-group" }, [
                _c(
                  "label",
                  {
                    staticClass: "control-label",
                    attrs: { for: "booking_id" },
                  },
                  [_vm._v("Booking ID:")]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "input-group" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.booking_id,
                        expression: "booking_id",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: {
                      type: "number",
                      id: "booking_id",
                      name: "booking_id",
                      placeholder: "Booking ID",
                    },
                    domProps: { value: _vm.booking_id },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.booking_id = $event.target.value
                      },
                    },
                  }),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-3" }, [
              _c("div", { staticClass: "form-group" }, [
                _c(
                  "label",
                  {
                    staticClass: "control-label",
                    attrs: { for: "payment_id" },
                  },
                  [_vm._v("Payment ID:")]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "input-group" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.payment_id,
                        expression: "payment_id",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: {
                      type: "number",
                      id: "payment_id",
                      name: "payment_id",
                      placeholder: "Payment ID",
                    },
                    domProps: { value: _vm.payment_id },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.payment_id = $event.target.value
                      },
                    },
                  }),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-3" }, [
              _c("div", { staticClass: "form-group" }, [
                _c(
                  "label",
                  { staticClass: "control-label", attrs: { for: "file_id" } },
                  [_vm._v("File ID:")]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "input-group" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.file_id,
                        expression: "file_id",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: {
                      type: "number",
                      id: "file_id",
                      name: "file_id",
                      placeholder: "File ID",
                    },
                    domProps: { value: _vm.file_id },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.file_id = $event.target.value
                      },
                    },
                  }),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-3" }, [
              _c("div", { staticClass: "form-group" }, [
                _c(
                  "label",
                  {
                    staticClass: "control-label",
                    attrs: { for: "message_id" },
                  },
                  [_vm._v("Message ID:")]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "input-group" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.message_id,
                        expression: "message_id",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: {
                      type: "number",
                      id: "message_id",
                      name: "message_id",
                      placeholder: "Message ID",
                    },
                    domProps: { value: _vm.message_id },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.message_id = $event.target.value
                      },
                    },
                  }),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-3" }, [
              _c("div", { staticClass: "form-group" }, [
                _c(
                  "label",
                  { staticClass: "control-label", attrs: { for: "talent_id" } },
                  [_vm._v("Talent ID:")]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "input-group" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.talent_id,
                        expression: "talent_id",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: {
                      type: "number",
                      id: "talent_id",
                      name: "talent_id",
                      placeholder: "Talent ID",
                    },
                    domProps: { value: _vm.talent_id },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.talent_id = $event.target.value
                      },
                    },
                  }),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-3" }, [
              _c("div", { staticClass: "form-group" }, [
                _c(
                  "label",
                  {
                    staticClass: "control-label",
                    attrs: { for: "endorsement_id" },
                  },
                  [_vm._v("Endorsement ID:")]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "input-group" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.endorsement_id,
                        expression: "endorsement_id",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: {
                      type: "number",
                      id: "endorsement_id",
                      name: "endorsement_id",
                      placeholder: "Endorsement ID",
                    },
                    domProps: { value: _vm.endorsement_id },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.endorsement_id = $event.target.value
                      },
                    },
                  }),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-3" }, [
              _c("div", { staticClass: "form-group" }, [
                _c(
                  "label",
                  {
                    staticClass: "control-label",
                    attrs: { for: "invoice_id" },
                  },
                  [_vm._v("Invoice ID:")]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "input-group" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.invoice_id,
                        expression: "invoice_id",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: {
                      type: "number",
                      id: "invoice_id",
                      name: "invoice_id",
                      placeholder: "Invoice ID",
                    },
                    domProps: { value: _vm.invoice_id },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.invoice_id = $event.target.value
                      },
                    },
                  }),
                ]),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "panel-footer" },
            [
              _c(
                "ladda-button",
                {
                  staticClass: "btn btn-sm btn-primary",
                  attrs: {
                    type: "submit",
                    click: _vm.handleAddManagerCallback,
                  },
                },
                [_vm._v("\n        Preview Notification\n      ")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm._l(_vm.textMessageMap, function (methodData, methodName) {
            return _c("div", { key: methodData.randomId }, [
              _c("div", { staticClass: "row m-t-lg" }),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-1" }, [
                methodData.channelSwitchEnabled === true
                  ? _c(
                      "div",
                      { staticClass: "flexibleItem" },
                      [
                        _c("toggle-button", {
                          staticClass: "pull-right date_unconfirmed",
                          attrs: {
                            color: {
                              checked: _vm.brandPrimary,
                              unchecked: "#b7b7b7",
                            },
                          },
                          on: {
                            change: function ($event) {
                              return _vm.toggleNotificationChannel(
                                methodData.active,
                                methodName,
                                methodData.notificationName
                              )
                            },
                          },
                          model: {
                            value: methodData.active,
                            callback: function ($$v) {
                              _vm.$set(methodData, "active", $$v)
                            },
                            expression: "methodData.active",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "row row-clear-md-4" },
                [
                  _c("div", {
                    attrs: { name: methodName },
                    domProps: { innerHTML: _vm._s(methodData.html) },
                  }),
                  _vm._v(" "),
                  _vm._l(methodData.data, function (item) {
                    return _c(
                      "div",
                      { key: item.randomId },
                      [
                        _c("TextContent", {
                          attrs: {
                            updatedValue: item.updatedValue,
                            updatedValueWithPlaceHolders:
                              item.updatedValueWithPlaceHolders,
                            method: item.methodName,
                            textTemplateId: item.textTemplateId,
                            notificationName: item.notificationName,
                            messageKey: item.key,
                          },
                        }),
                      ],
                      1
                    )
                  }),
                ],
                2
              ),
            ])
          }),
        ],
        2
      ),
      _vm._v(" "),
      _c("div", { staticClass: "row row-clear-md-4" }, [
        _c("div", {
          attrs: { id: "email-preview" },
          domProps: { innerHTML: _vm._s(_vm.emailContent) },
        }),
      ]),
      _vm._v(" "),
      _vm.emailParts
        ? _c(
            "div",
            _vm._l(_vm.emailParts, function (emailPart) {
              return _c(
                "div",
                { key: emailPart.randomId },
                [
                  _c("NotificationContent", {
                    attrs: {
                      notificationOriginalContent: emailPart.originalContent,
                      notificationSavedContent: emailPart.savedContent,
                      partId: emailPart.id,
                      emailTemplate: _vm.emailTemplate,
                      notificationTemplateId: _vm.emailNotificationTemplateId,
                    },
                  }),
                ],
                1
              )
            }),
            0
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }